export * from './paragraph.component';
export * from './paragraph.module';
